<template>
  <div class="content blacklist">
    <div class="header">
      <div class="row">
        <div class="box">
          <div class="title">提现账号</div>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="param.account">
          </el-input>
          <div style="margin-left: 12px">
            <el-button size="small" type="primary" @click="getData(1)">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <template>
      <el-table :data="tableData" style="width: 100%" size="medium">
        <el-table-column prop="apply_amount" label="申请金额"></el-table-column>
        <el-table-column prop="fee" label="手续费" ></el-table-column>
        <el-table-column prop="amount" label="打款金额" ></el-table-column>
        <el-table-column prop="show_type" label="提现方式" ></el-table-column>
        <el-table-column prop="account" label="打款账号" ></el-table-column>
        <el-table-column prop="create_time" label="申请时间" ></el-table-column>
        <el-table-column prop="mobile" label="手机号" ></el-table-column>
        <!-- <el-table-column prop="level_name" label="分销等级" ></el-table-column> -->
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <el-button type="text" @click="agreeItem(scope.row.id)">通过</el-button>
            <el-button type="text" @click="refuseItem(scope.row.id)">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next, total"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="show_refuse" width="400px" title="申请驳回" @close="closeRefuse()">
      <el-form size="small" label-width="90px">
        <el-form-item label="驳回原因">
          <el-input type="textarea" :rows="3" v-model="refuse_reason" style="width:240px;"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align:center">
        <el-button size="small" type="primary" @click="submitRefuse()">确定</el-button>
        <el-button size="small" @click="closeRefuse()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getWithdrawList,withdrawAgree,withdrawRefuse } from '@/api/user';
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      tableData: [],
      page: 1,
      total: 0,
      param: {
        account: "",
      },
      show_refuse: false,
      refuseId: "",
      refuse_reason: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData(i) {
      this.page = i || this.page;
      var data = {
        app_id: this.app_id,
        page: this.page,
        status: 0,
      }
      if(this.param.account != ""){
        data.account = this.param.account
      }
      getWithdrawList(data).then(res => {
        if(res.code == 200) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.tableData.forEach(item => {
            item.show_type = item.account_type == 1? "余额":item.account_type == 2? "微信钱包":item.account_type == 3? "支付宝":item.account_type == 4? "银行卡":"";
          })
        }else{
          this.$message(res.msg)
        }
      })
    },
    handleCurrentChange(val){
      this.page = val;
      this.getData();
    },
    agreeItem(id){
      var data = {
        app_id: this.app_id,
        id: id
      }
      withdrawAgree(data).then(res => {
        if(res.code == 200) {
          this.$message.success(res.msg);
          this.getData();
        }else{
          this.$message(res.msg);
        }
      })
    },
    refuseItem(id){
      this.refuseId = id;
      this.show_refuse = true;
    },
    closeRefuse(){ 
      this.show_refuse = false;
      this.refuse_reason = "";
    },
    submitRefuse(){
      var data = {
        app_id: this.app_id,
        id: this.refuseId,
        refuse_reason: this.refuse_reason
      }
      withdrawRefuse(data).then(res => {
        if(res.code == 200) {
          this.$message.success(res.msg);
          this.closeRefuse();
          this.getData();
        }else{
          this.$message(res.msg)
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    padding: 10px 10px;
    
    .row{
      display: flex;
      padding: 6px 0;
    }
    .box{
      width: 35%;
      line-height: 40px;
      display: flex;
      .title{
        width:120px;
        padding-right: 20px;
        text-align: right;
      }
    }
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
.page{
  margin-top: 15px;
}
</style>

<style lang="scss">
.blacklist {
  .has-gutter > tr > th {
    color: #333;
    background-color: #f8f8f8;
  }
  .cell {
    text-align: center;
  }
}
</style>
